import React from "react";
import TalentSelected from "svg/talenttree/Talent_Selected.svg";
import TalentUnselected from "svg/talenttree/Talent_Unselected.svg";
import TalentUnselectedArrowRight from "svg/talenttree/Talent_Unselected_Arrow_Right.svg";
import TalentUnselectedArrowLeft from "svg/talenttree/Talent_Unselected_Arrow_Left.svg";
import TalentSelectedArrowRight from "svg/talenttree/Talent_Selected_Arrow_Right.svg";
import TalentSelectedArrowLeft from "svg/talenttree/Talent_Selected_Arrow_Left.svg";
import Failed_to_Load_Image from "images/wow/WowIcon.png";
import TalentBoarder from "svg/talenttree/Talent_Border.svg";
import classNames from "classnames";

const OctagonTalentIcon = (props) => {
  const { staticDataImg, talentSelectedNumber, talentMaxNumber, spriteData } = props;
  let iconSize = props.iconSize ? props.iconSize : "36px";

  return (
    <div className={`octagon-talent-icon ${props.className}`}>
      {props.color ? (
        <div className="octagon-talent-icon-container">
          <img src={TalentSelected} className="octagon-talent-icon-octagon" />
          <img src={TalentBoarder} className="octagon-talent-icon-octagon-border" />
          <img src={TalentSelectedArrowRight} className="octagon-talent-icon-right-arrow" />
          <img src={TalentSelectedArrowLeft} className="octagon-talent-icon-left-arrow" />
          {/* {talentSelectedNumber !== undefined ? (
            <div className="wow-icon-talent-number">
              {talentSelectedNumber}/{talentMaxNumber}
            </div>
          ) : null} */}
        </div>
      ) : (
        <div className="octagon-talent-icon-container">
          <img src={TalentUnselected} className="octagon-talent-icon-octagon" />
          <img
            src={TalentBoarder}
            className="octagon-talent-icon-octagon"
            style={{
              width: "34px",
              height: "34px",
              top: "1px",
              right: "-35px",
              position: "absolute",
              zIndex: "50",
            }}
          />
          <img src={TalentUnselectedArrowRight} className="octagon-talent-icon-right-arrow" />
          <img src={TalentUnselectedArrowLeft} className="octagon-talent-icon-left-arrow" />
        </div>
      )}
      <div className="octagon-talent-image-container">
        <div className="octagon-talent-image-cropper">
          {spriteData ? (
            <div
              className={classNames("wow-icon-talent-sprite octagon-talent-image-cropper-correction", {
                "image-greyout": !props.color,
              })}
              style={{
                height: spriteData.height,
                width: spriteData.width,
                backgroundImage: `url(${staticDataImg})`,
                backgroundPosition: `-${spriteData.left}px -${spriteData.top}px`,
              }}
            />
          ) : (
            <img
              src={staticDataImg ?? Failed_to_Load_Image}
              className={classNames("octagon-talent-image-cropper-correction", {
                "image-greyout": !props.color,
              })}
              style={props.color ? null : { filter: "grayscale(100%)", opacity: "0.27" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default OctagonTalentIcon;
